var _linearGradient, _linearGradient2, _path, _path2, _path3, _rect, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect2, _circle, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _rect3, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _rect4, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _rect5, _path164, _rect6, _rect7, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 613.577,
    viewBox: "0 0 747.534 613.577",
    width: 747.534,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x2: 1,
    y1: 0.5,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f94f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f66363"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    xlinkHref: "#a",
    y1: 0,
    y2: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m533.333 77.118a54.69 54.69 0 0 0 -5.857-14.118l5.963-8.967-8.271-8.271-8.268-8.27-8.965 5.961a54.735 54.735 0 0 0 -14.122-5.853l-2.124-10.547h-23.389l-2.126 10.547a54.688 54.688 0 0 0 -14.118 5.855l-8.967-5.961-8.272 8.271-8.271 8.271 5.964 8.964a54.686 54.686 0 0 0 -5.855 14.118l-10.549 2.122v23.394l10.549 2.122a54.721 54.721 0 0 0 5.855 14.119l-5.963 8.965 8.271 8.271 8.272 8.271 8.967-5.961a54.749 54.749 0 0 0 14.118 5.857l2.122 10.546h23.392l2.124-10.546a54.8 54.8 0 0 0 14.118-5.857l8.965 5.961 8.272-8.271 8.271-8.271-5.963-8.965a54.725 54.725 0 0 0 5.857-14.119l10.546-2.122v-23.394zm-53.339 54.805a40.985 40.985 0 1 1 40.984-40.986 40.986 40.986 0 0 1 -40.984 40.986z",
    fill: "url(#a)",
    transform: "translate(144.155 -27.051)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m517.8 126.407a25.062 25.062 0 0 0 -2.686-6.473l2.734-4.111-3.792-3.792-3.791-3.791-4.11 2.734a25.133 25.133 0 0 0 -6.471-2.686l-.974-4.835h-10.728l-.974 4.835a25.112 25.112 0 0 0 -6.471 2.686l-4.111-2.734-3.792 3.791-3.791 3.792 2.734 4.111a25.06 25.06 0 0 0 -2.684 6.473l-4.836.973v10.72l4.836.974a25.048 25.048 0 0 0 2.684 6.471l-2.734 4.111 3.791 3.791 3.792 3.792 4.111-2.732a25.109 25.109 0 0 0 6.471 2.684l.974 4.835h10.724l.974-4.835a25.13 25.13 0 0 0 6.471-2.684l4.11 2.732 3.791-3.792 3.792-3.791-2.734-4.111a25.051 25.051 0 0 0 2.686-6.471l4.834-.974v-10.72zm-24.454 25.124a18.789 18.789 0 1 1 18.79-18.79 18.788 18.788 0 0 1 -18.793 18.79z",
    fill: "url(#a)",
    transform: "translate(175.648 23.13)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h57.54v174.77h-57.54z",
    fill: "#aebecc",
    transform: "matrix(-1 0 0 -1 411.116 522.178)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ececec",
    height: 350.507,
    rx: 15.253,
    transform: "matrix(-1 0 0 -1 630.774 431.595)",
    width: 496.856
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h457.939v332.886h-457.939z",
    fill: "#fff",
    transform: "matrix(-1 0 0 -1 611.314 376.669)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h457.939v40.207h-457.939z",
    fill: "url(#a)",
    transform: "matrix(-1 0 0 -1 611.314 83.99)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m299.048 275.921a16.026 16.026 0 1 0 16.026-16.021 16.026 16.026 0 0 0 -16.026 16.021z",
    fill: "#757575",
    transform: "translate(67.271 125.88)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#dfe1e8"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 11.914,
    rx: 3.502,
    transform: "matrix(-1 0 0 -1 450.279 124.5)",
    width: 160.944
  }), /*#__PURE__*/React.createElement("rect", {
    height: 11.915,
    rx: 3.502,
    transform: "matrix(-1 0 0 -1 450.279 145.988)",
    width: 160.944
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.5 0h153.94a3.5 3.5 0 0 1 3.5 3.5v4.912a3.5 3.5 0 0 1 -3.5 3.5h-153.94a3.5 3.5 0 0 1 -3.5-3.5v-4.912a3.5 3.5 0 0 1 3.5-3.5z",
    transform: "matrix(-1 0 0 -1 450.279 167.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.935 302.237h-171.659a25.989 25.989 0 0 1 -25.959-25.96v-104.418a25.99 25.99 0 0 1 25.959-25.959h171.659a25.989 25.989 0 0 1 25.959 25.959v104.418a25.988 25.988 0 0 1 -25.959 25.96zm-171.659-153.083a22.731 22.731 0 0 0 -22.7 22.7v104.423a22.732 22.732 0 0 0 22.7 22.706h171.659a22.732 22.732 0 0 0 22.7-22.706v-104.418a22.731 22.731 0 0 0 -22.7-22.7z",
    transform: "translate(-8.74 51.009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.92 0h153.592a6.92 6.92 0 0 1 6.92 6.92v11.27a6.92 6.92 0 0 1 -6.92 6.92h-153.593a6.919 6.919 0 0 1 -6.919-6.919v-11.271a6.92 6.92 0 0 1 6.92-6.92z",
    transform: "matrix(-1 0 0 -1 370.081 236.262)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m252.914 515.579h258.863v13.193h-258.863z",
    fill: "#ececec"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m445.38 181.38a37.271 37.271 0 0 1 -25.518 35.371c-.224.076-.449.149-.674.217a37.267 37.267 0 1 1 26.192-35.588z",
    fill: "#eef0f7",
    transform: "translate(114.435 49.838)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m388.05 170.641s-2.547-16.464 11.091-16.16 13.453 8.445 13.211 16.527-5.468 7.472.424 18.712-5.1 11.24-5.1 11.24l-8.533-11.725z",
    fill: "#3c4145",
    transform: "translate(125.604 56.642)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m397.585 155.509s-9.235 1.458-9.6 14.58 2.488 15.919 10.57 13.185 10.632-16.465 10.816-18.591.67-10.754-11.786-9.174z",
    fill: "#eea886",
    transform: "translate(125.667 57.194)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m416.971 188.162c.025 3.932-2.076 6.561-5.174 8.241-.224.076-.449.149-.674.217a37.4 37.4 0 0 1 -27.632-2.2c-1.123-2.24.5-5.421 3.807-10.3 2.27-3.357 4.495-6.783 8.3-8.448 5.618-.895 11.563-.948 15.751 1.418 3.34 1.884 5.564 5.31 5.622 11.072z",
    fill: "#e55353",
    transform: "translate(122.501 70.186)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m388.424 183.276-4.246 6.692c.01-.036.292-1.049.77-3.985.093-.557.19-1.183.295-1.884a4.99 4.99 0 0 1 .134-.618c1.817-4.19 7.485-7.307 7.691-7.411z",
    fill: "#e55353",
    transform: "translate(123.185 70.825)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m409.661 192.448a37.041 37.041 0 0 1 -7.065 3.2c-.224.076-.449.149-.674.217-.941-2.431-1.76-4.535-1.937-5.078-.051-.159-.172-.454-.338-.853-.765-1.861-2.48-6-2.5-9.235-.012-2.088.678-3.8 2.777-4.284a5.5 5.5 0 0 1 2.228-.085c2.344.426 3.713 2.532 4.477 4.4.013.031.025.063.036.093a14.46 14.46 0 0 1 .835 2.977s.038.147.1.411c.133.52.384 1.509.712 2.8.376 1.489.846 3.381 1.349 5.437z",
    fill: "#eea886",
    transform: "translate(131.701 70.943)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m402.2 168.7c-.8 1.511-1.647 10.893-1.647 10.893s-11.294 4.27-10.138 1.856a9.269 9.269 0 0 0 .689-3.744 18.093 18.093 0 0 0 -.126-2.28c-.03-.247-.053-.389-.053-.389s12.075-7.848 11.275-6.336z",
    fill: "#eea886",
    transform: "translate(127.224 65.858)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m393.807 165.014s4.738 7.716 9.053 10.754 2.126 5.467 2.126 5.467 11.255-23.7.555-25.336-17.262-1.763-17.565 14.277c-.001.001 4.858-5.284 5.831-5.162z",
    fill: "#3c4145",
    transform: "translate(125.679 57.107)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m397.158 172.1c-1.733 2.556-6.314 3.246-6.314 3.246a18.106 18.106 0 0 0 -.126-2.28c2.942.567 6.44-.966 6.44-.966z",
    fill: "#a77860",
    transform: "translate(127.48 68.217)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m385.092 183.45a9.6 9.6 0 0 0 -.447 2.551l1.665-2.51s2.971-4.26 3.99-5.368a15.573 15.573 0 0 1 2.492-2.079s-5.924 2.81-7.7 7.406z",
    fill: "#bd4444",
    transform: "translate(123.49 70.808)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m399.5 189.7s7.248-2.843 9.394-3.009c0 0-1.458-11.641-8.579-10.406s-.815 13.415-.815 13.415z",
    fill: "#e55353",
    transform: "translate(131.557 70.907)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m392.2 175.954s-5.322 8.183-3.521 8.9 11.554-.954 15.7-8.726c.004-.002-6.196-3.181-12.179-.174z",
    fill: "#eea886",
    transform: "translate(125.898 69.899)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m462.584 120.214a48.484 48.484 0 1 1 -48.484-48.485 48.484 48.484 0 0 1 48.484 48.485z",
    fill: "#eef0f7",
    transform: "translate(110.994 2.293)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m438.981 121.612-3.575 12.83a48.224 48.224 0 0 1 -22.05 8.537c-1.435.177-2.891.288-4.361.336-.53.018-1.06.025-1.592.025q-2.353 0-4.651-.219a48.339 48.339 0 0 1 -24.864-9.795c-.686-4.243-1.422-8.938-2.069-13.329 3.564-1.327 14.9-5.184 22.064-7.6.1-.035.2-.066.3-.1.157-.055.313-.108.467-.157l1.213-.411c.393-.133.765-.257 1.113-.378 1.468-.492 2.5-.84 2.87-.964l.147-.05h.083l9.626.721 1.614.119.5.038.22.055c.578.147 2.267.59 4.5 1.272h.01c5.704 1.747 14.954 5.058 18.435 9.07z",
    fill: "#d9c7c1",
    transform: "translate(117.695 27.648)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#eea987"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m401.953 86.514s11.545 1.948 9.585 20.019-12.146 16.479-12.827 16.452-10.249.219-10.754-21.878c-.001 0-.148-16.336 13.996-14.593z",
    transform: "translate(125.666 11.919)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.467 106.142s-.4 7.437.3 9.056-9.268 6.741-15.465.906c0 0 1.253-8.128.863-11s14.302 1.038 14.302 1.038z",
    transform: "translate(127.21 23.523)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.63 95.694s1.281-1.339 1.731.035-2.046 7.466-1.89 7.742c0 0-.237.529-.538.232s.697-8.009.697-8.009z",
    transform: "translate(134.808 17.649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.756 95.417s-1.224-1.39-1.73-.035 1.34 7.436 1.569 7.812c0 0 .4.625.711.341s-.55-8.118-.55-8.118z",
    transform: "translate(124.998 17.439)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m412.832 101.082c-.4 2.472-.774 4.311-.774 4.311l-1.68 2.194a44.242 44.242 0 0 0 -.157-5.613c-.1-.288-.212-.8-.328-1.355-.194-.913-.391-1.945-.527-2.288-.215-.55-9.893-3.375-18.511.591 0 0 .073.747.068 1.581 0 .968-.111 2.051-.553 2.215-.827.3-.482 5.678-.482 5.678l-1.344-1.551s-.388-2.808-.77-6.036l-.005-.023c-.085-.752-.174-1.526-.258-2.295-.192-3.246.129-9.141 4.356-12.6 2.853-1.221 7.408-2.258 15 .065a5.24 5.24 0 0 1 2.228.587c4.726 5.2 3.737 14.539 3.737 14.539z",
    fill: "#e8734d",
    transform: "translate(125.346 10.725)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m391.306 107.017s1.842 2.558 6.124 2.462 6.138-2.328 6.138-2.328-2.028 4.238-6.16 4.192-6.102-4.326-6.102-4.326z",
    fill: "#c78d71",
    transform: "translate(127.866 25.47)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m389.6 112.289s3.093 5.385 8.963 5.893c3.723.321 6.945-4.4 8.456-6.715a22.547 22.547 0 0 0 -17.419.822z",
    fill: "#eea987",
    transform: "translate(126.744 27.495)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m402.393 109.9a32.026 32.026 0 0 1 -7.386 6.4l3.125 4.818 5.332-9.515z",
    fill: "#eddad3",
    transform: "translate(130.297 27.362)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m391.192 110.332a21.468 21.468 0 0 0 7.553 5.679l-3.433 4.962-6-8.68z",
    fill: "#eddad3",
    transform: "translate(126.559 27.648)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m396.1 113.76 2.679 4.077a5.581 5.581 0 0 1 -5.429-.1z",
    fill: "#5073ab",
    transform: "translate(129.207 29.899)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m427.2 120.465c-.461 1.657-1.151 4.067-2.972 10.688-.555.48-1.123.953-1.7 1.4-.651.515-1.319 1.012-2 1.5a48.224 48.224 0 0 1 -22.05 8.537c.717-16.783 2.711-31.666 2.711-31.666q2.358.619 4.472 1.229h.01c12.3 3.531 18.543 6.631 20.67 7.805.017.008.032.018.046.026.552.316.813.481.813.481z",
    fill: "#323657",
    transform: "translate(132.575 28.037)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m399.752 141.558a48.486 48.486 0 0 1 -24.715-13.358c-.3-.3-.591-.6-.88-.913-.85-3.6-1.415-5.956-1.45-6.109v-.008s6-3.942 27.221-9.6v.012c-.001.485.011 14.099-.176 29.976z",
    fill: "#323657",
    transform: "translate(115.65 28.461)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m398.467 117.077c-.2 4.42-.217 13-.149 22.781-.53.018-1.06.025-1.592.025q-2.353 0-4.651-.219a149.062 149.062 0 0 1 3.221-22.6c.235-.977.378-1.465.378-1.465l2.846.469c-.02.308-.038.644-.053 1.009z",
    fill: "#5073ab",
    transform: "translate(128.371 31.107)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m420.11 121.879a48.877 48.877 0 0 1 -5.418 5.492c-.555.48-1.123.953-1.7 1.4l4.676-12.093c1.132.966 2.054 4.255 2.442 5.201z",
    fill: "#323657",
    transform: "translate(142.108 31.819)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m375.682 124.4c-.3-.3-.591-.6-.88-.913a47.244 47.244 0 0 1 -3.078-3.6 5.607 5.607 0 0 1 1.627-2.515v.008z",
    fill: "#323657",
    transform: "translate(115.005 32.268)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f5f7ff",
    height: 15.193,
    rx: 3.296,
    width: 65.314,
    x: 172.503,
    y: 56.29
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.26,
    cy: 37.26,
    fill: "#eef0f7",
    r: 37.26,
    transform: "matrix(.99991341 -.0131594 .0131594 .99991341 484.806 283.247)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m394.091 240.95a1.879 1.879 0 0 1 -1.877-1.877v-25.959a1.876 1.876 0 1 1 3.753 0v25.959a1.876 1.876 0 0 1 -1.876 1.877z",
    fill: "#949494",
    transform: "translate(128.462 93.921)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m412.216 222.824h-25.959a1.877 1.877 0 0 1 0-3.754h25.959a1.877 1.877 0 0 1 0 3.754z",
    fill: "#949494",
    transform: "translate(123.317 99.067)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m4.414 0h26.119a4.413 4.413 0 0 1 4.413 4.413v26.121a4.413 4.413 0 0 1 -4.413 4.413h-26.119a4.414 4.414 0 0 1 -4.414-4.414v-26.119a4.414 4.414 0 0 1 4.414-4.414z",
    fill: "url(#b)",
    transform: "translate(415.332 198.536)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m342.248 168.178-8.834-7.7a1.74 1.74 0 1 1 2.288-2.623l6.246 5.446 8.909-9.937a1.741 1.741 0 1 1 2.591 2.324z",
    fill: "#f3f3f3",
    transform: "translate(89.451 55.529)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m4.414 0h26.12a4.413 4.413 0 0 1 4.413 4.413v26.12a4.414 4.414 0 0 1 -4.414 4.414h-26.119a4.414 4.414 0 0 1 -4.414-4.414v-26.119a4.414 4.414 0 0 1 4.414-4.414z",
    fill: "url(#b)",
    transform: "translate(415.332 243.319)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m342.248 195.208-8.834-7.7a1.74 1.74 0 1 1 2.288-2.623l6.246 5.446 8.909-9.937a1.741 1.741 0 1 1 2.591 2.324z",
    fill: "#f3f3f3",
    transform: "translate(89.451 73.282)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m4.414 0h26.119a4.413 4.413 0 0 1 4.413 4.413v26.12a4.414 4.414 0 0 1 -4.414 4.414h-26.118a4.414 4.414 0 0 1 -4.414-4.415v-26.118a4.414 4.414 0 0 1 4.414-4.414z",
    fill: "url(#b)",
    transform: "translate(415.332 288.103)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m247.939 352.714a26.868 26.868 0 0 1 -3.275 5.578c-1.5 1.584-7.237 4.414-7.268 9.117-.033 5.1 9.672 3.685 13.468 3.5s4.084-2.909 5.681-5.8 3.211-2.4 3.509-4.727-1.223-7.542-1.223-7.542z",
    fill: "#131c24",
    transform: "translate(26.778 186.844)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m243.769 352.093-.278 2.417s5.971 2 11.614.21l-.315-3.305z",
    fill: "#4f4946",
    transform: "translate(30.782 185.991)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m290.819 352.714a26.834 26.834 0 0 0 3.274 5.578c1.5 1.584 7.238 4.414 7.268 9.117.035 5.1-9.672 3.685-13.468 3.5s-4.084-2.909-5.68-5.8-3.211-2.4-3.511-4.727 1.224-7.542 1.224-7.542z",
    fill: "#131c24",
    transform: "translate(53.883 186.844)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m290.594 352.093.278 2.417s-5.971 2-11.614.21l.313-3.305z",
    fill: "#4f4946",
    transform: "translate(54.274 185.991)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m312.238 351.693c0 6.288 5.872 63.689 5.872 63.689-.674 2.1-15.083 1.839-17.33.794s-8.781-57.935-9.2-64.274-9.8-61.475-11.767-61.265-11.309 59.293-12.885 64.115-8.71 61.971-8.71 61.971c-4.944 2.722-16.7-.686-16.7-.686s2.465-58.676 2.747-60.448c.418-2.623-.02-9.687 1.123-25.371 1.024-14.028 4.72-44.571 7.063-61.111.085-.588.164-1.153.242-1.695.459-3.219.8-5.585.968-6.718.071-.49.111-.752.111-.752.631-.27 1.292-.522 1.98-.751 16.462-5.515 47.8-5.164 47.8-5.164s.432 5.631.467 5.906c.041.331.108.853.192 1.528.184 1.458.457 3.63.77 6.152 0 .017 0 .035.005.053l.03.23c1.107 8.972 2.672 22.1 2.525 23.47-.223 2.096 4.697 54.04 4.697 60.327z",
    fill: "#293e4f",
    transform: "translate(29.489 122.024)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m311.452 205.375-8.087 29.016c-.278.941-.608 2.1-.959 3.444l-.015.051a.234.234 0 0 0 -.01.036 114.129 114.129 0 0 0 -3.517 21.815c-.336 5.971.77 29.976.77 29.976s-12.237 4.568-30.55 3.41c0 0-19.7-.461-18.091-12.537 4.248-31.965.093-45.144-.464-48.354 0 0-2.328-14.727-4.241-27.735 5.544-2.064 28.875-10.822 28.875-10.822l12.265.918s18.64 4.59 24.024 10.782z",
    fill: "#d9c7c1",
    transform: "translate(32.62 82.388)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m273.187 168.973s11.97 2.02 9.941 20.763-12.6 17.09-13.307 17.063-10.628.225-11.152-22.691c-.001-.001-.153-16.945 14.518-15.135z",
    fill: "#eea987",
    transform: "translate(40.75 66.075)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m276.83 189.329s-.413 7.716.316 9.394-9.614 6.99-16.041.939c0 0 1.3-8.431.9-11.409s14.825 1.076 14.825 1.076z",
    fill: "#eea987",
    transform: "translate(42.351 78.109)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m273.887 178.493s1.329-1.388 1.794.036-2.121 7.744-1.96 8.031c0 0-.245.548-.557.242s.723-8.309.723-8.309z",
    fill: "#eea987",
    transform: "translate(50.233 72.018)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m259.5 178.206s-1.271-1.441-1.794-.036 1.39 7.714 1.629 8.1c0 0 .411.648.737.353s-.572-8.417-.572-8.417z",
    fill: "#eea987",
    transform: "translate(40.058 71.8)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m284.468 184.115c-.413 2.565-.8 4.47-.8 4.47l-1.743 2.276a46.136 46.136 0 0 0 -.164-5.822c-.1-.3-.22-.83-.341-1.4-.2-.948-.4-2.018-.545-2.376-.225-.568-10.261-3.5-19.2.616 0 0 .076.774.07 1.637 0 1-.113 2.129-.573 2.3-.857.312-.5 5.888-.5 5.888l-1.393-1.609s-.4-2.913-.8-6.259v-.023c-.089-.782-.182-1.586-.27-2.381-.2-3.367.134-9.48 4.518-13.072 2.959-1.266 11.043-2.542 15.557.068a34.5 34.5 0 0 1 2.923 1.99c4.899 5.392 3.261 13.697 3.261 13.697z",
    fill: "#e8734d",
    transform: "translate(40.417 64.804)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m262.143 190.237s1.91 2.654 6.35 2.553 6.365-2.414 6.365-2.414-2.1 4.4-6.387 4.349-6.328-4.488-6.328-4.488z",
    fill: "#c78d71",
    transform: "translate(43.032 80.13)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m260.369 195.707s3.209 5.585 9.3 6.112c3.862.333 7.174-4.573 8.743-6.975a23.341 23.341 0 0 0 -18.043.863z",
    fill: "#eea987",
    transform: "translate(41.867 82.228)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m273.641 193.225a33.218 33.218 0 0 1 -7.661 6.637l3.242 5 5.529-9.9z",
    fill: "#eddad3",
    transform: "translate(45.553 82.092)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m262.01 193.676a22.267 22.267 0 0 0 7.832 5.89l-3.559 5.146-6.183-8.788z",
    fill: "#eddad3",
    transform: "translate(41.691 82.388)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m267.11 197.231 2.779 4.228a5.781 5.781 0 0 1 -5.63-.1z",
    fill: "#5073ab",
    transform: "translate(44.422 84.723)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m248.724 257.323s15.021 5.542 48.993.323l-.452-6.152s-19.691 5.809-47.941.833z",
    fill: "#1a2833",
    transform: "translate(34.219 120.363)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m272.493 194.269s-3.512 26.275-3.03 48.909 7.832 65.074 7.832 65.074 13.1-1.284 16.353-5.378c0 0-7.517-40.847-7.3-46.9s9.634-51.581 9.634-51.581-3.682-4.912-23.489-10.124z",
    fill: "#385369",
    transform: "translate(47.81 82.778)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m269.578 195.1s-.033 24.9-.514 47.535-3.464 64.765-3.464 64.765-15.368-2.189-18.621-6.283c0 0 5.418-39.634 5.2-45.688s-6.949-51.135-6.949-51.135 2.335-3.323 24.348-9.194z",
    fill: "#385369",
    transform: "translate(31.928 83.322)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m303.429 373.75h9.23v6.862h-9.23z",
    fill: "#3e5e78"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m267 199.138s-4.122 14.07-4.483 42.013.507 35.957.507 35.957l3.217 6.369 4.289-6.645s-1.375-64.3-.578-77.205z",
    fill: "#5073ab",
    transform: "translate(43.224 85.976)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m275.58 225.1s6.1-3.068 6.947-3.61 11.038-2.049 12.322-2.008 1.34 1.064.978 1.428-10.549 2.036-10.724 2.28.862.154.862.154 10.98-.169 11.745.567-.113 1.432-.557 1.615c0 0 1 1.148-.156 1.62a17.08 17.08 0 0 1 -2.717.775s1.451.747.5 1.413-12.588 4.27-12.588 4.27-4.331-8.269-6.612-8.504z",
    fill: "#eea886",
    transform: "translate(51.858 99.338)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m308.642 260.744c-7.929 1.894-26.257-1.18-33.24-2.719-1.481-.326-3.151-.668-4.871-1.006-2.856-.56-5.837-1.108-8.258-1.538-2.981-.534-5.11-.89-5.11-.89s38.466-8.642 39.886-8.642-3.551-22.486-3.551-22.486-4.954-18.833-2.382-26.234c0 0 9.76 2.959 12.918 5.216 1.763 1.258 3.058 9.426 4.258 14.981 1.523 7.038 5.058 23.069 5.459 26.452.364 3.085 2.822 14.974-5.109 16.866z",
    fill: "#385369",
    transform: "translate(39.759 84.723)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m261.387 197.286s-11.815 4.036-12.381 5.57c-2.389 6.491-3.5 13.586-4.273 16.429-.943 3.474-3.08 13.866-3.632 17.254-.7 4.321-2.048 19.628-1.46 21.989.739 2.981 7.764 2.764 11.553 2.174s56.414-13.4 56.414-13.4-3-9.79-3.153-10.657c0 0-40.568 4.637-45.736 5.739a33.964 33.964 0 0 0 -3.59.87s8.947-36.72 6.258-45.968z",
    fill: "#385369",
    transform: "translate(28.158 84.759)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m265.568 227.573s-5.3-4.311-6.006-5.022-10.338-4.377-11.6-4.614a1.063 1.063 0 0 0 -1.383 1.272c.167.881 9.982 4.17 10.1 4.447s-.873-.035-.873-.035-10.686-2.53-11.594-1.977-.2 1.42.2 1.7c0 0-1.223.908-.2 1.617a17.109 17.109 0 0 0 2.485 1.34s-1.577.419-.789 1.274 6.412 2.142 6.412 2.142 10.969-2.409 13.248-2.144z",
    fill: "#eea886",
    transform: "translate(30.966 98.299)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m286.349 228.593-17.849 7.828c-2.856-.56-5.837-1.108-8.258-1.538z",
    fill: "#263947",
    transform: "translate(41.785 105.322)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m270.809 169.054s2.969-1.5 4.574.464 1.779 12.63-.181 16.724.312-14.542-4.393-17.188z",
    fill: "#e8734d",
    transform: "translate(48.724 65.858)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m201.152 340.661h5.312v241.47h-5.312z",
    fill: "#706865"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m9.624 0h155.552a9.624 9.624 0 0 1 9.624 9.624v283.246a9.624 9.624 0 0 1 -9.624 9.624h-155.551a9.625 9.625 0 0 1 -9.625-9.625v-283.245a9.624 9.624 0 0 1 9.624-9.624z",
    fill: "#bdafaa",
    transform: "translate(55.077 239.781)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 285.803,
    rx: 9.509,
    width: 165.207,
    x: 59.874,
    y: 244.653
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m116.433 237.488h52.088v11.763h-52.088z",
    fill: "#706865"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m242.683 376.506h-105.745a15.552 15.552 0 0 1 -15.538-15.534v-60.2a15.553 15.553 0 0 1 15.536-15.536h105.747a15.553 15.553 0 0 1 15.536 15.536v60.2a15.552 15.552 0 0 1 -15.536 15.534zm-105.745-89.267a13.551 13.551 0 0 0 -13.538 13.535v60.2a13.549 13.549 0 0 0 13.538 13.526h105.745a13.549 13.549 0 0 0 13.534-13.533v-60.2a13.551 13.551 0 0 0 -13.534-13.534z",
    fill: "#ffe5e5",
    transform: "translate(-49.406 142.526)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m137.348 252.442a.042.042 0 0 0 -.025 0c.103.043.118.048.025 0z",
    fill: "#323657",
    transform: "translate(-38.949 120.984)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m199.6 262.179a17.233 17.233 0 1 1 17.232-17.234 17.253 17.253 0 0 1 -17.232 17.234zm0-32.465a15.231 15.231 0 1 0 15.229 15.231 15.247 15.247 0 0 0 -15.229-15.231z",
    fill: "#ffe5e5",
    transform: "translate(-9.366 104.743)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m199.6 286.146a17.233 17.233 0 1 1 17.232-17.232 17.254 17.254 0 0 1 -17.232 17.232zm0-32.463a15.23 15.23 0 1 0 15.229 15.231 15.247 15.247 0 0 0 -15.229-15.231z",
    fill: "#ffe5e5",
    transform: "translate(-9.366 120.485)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m163.584 273.97c-1.422 0-2.861-.07-4.279-.2a44.618 44.618 0 0 1 -27.4-12.986c-.29-.292-.563-.577-.815-.843-.987-1.045-1.942-2.162-2.831-3.312a44.21 44.21 0 0 1 -9.315-27.294 44.691 44.691 0 0 1 44.641-44.641v2a42.686 42.686 0 0 0 -42.639 42.638 42.211 42.211 0 0 0 8.9 26.066 41.346 41.346 0 0 0 2.707 3.166c.24.26.5.53.775.807a42.476 42.476 0 0 0 26.169 12.4c1.355.128 2.732.194 4.091.194.5 0 .953-.008 1.4-.022 1.294-.043 2.585-.141 3.837-.3a42.584 42.584 0 0 0 19.391-7.5c.6-.431 1.195-.875 1.755-1.317.487-.383.991-.8 1.5-1.236a43.289 43.289 0 0 0 4.765-4.83 42.685 42.685 0 0 0 9.99-27.43 43.251 43.251 0 0 0 -.456-6.256l1.982-.292a45.405 45.405 0 0 1 .477 6.548 44.685 44.685 0 0 1 -10.461 28.717 45.227 45.227 0 0 1 -4.989 5.058c-.53.457-1.06.893-1.569 1.292-.585.461-1.2.925-1.834 1.375a44.608 44.608 0 0 1 -20.306 7.862c-1.311.164-2.663.267-4.016.311-.473.017-.954.025-1.47.025z",
    fill: "#ffe5e5",
    transform: "translate(-51.021 76.486)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m190.719 244.98a3.738 3.738 0 0 0 -.436-.485.735.735 0 0 0 -.229-.186.384.384 0 0 0 -.04-.025c-8.322-4.6-23.338-8.354-23.338-8.354-.436-1-.4-4.475-.338-6.551 1.557-1.808 2.969-4.636 3.759-9.048.254.187.446-.242.446-.242-.139-.247 2.106-5.731 1.7-6.967a.649.649 0 0 0 -1.059-.418q.082-.472.166-1s.89-8.4-3.365-13.089a4.709 4.709 0 0 0 -2.006-.527c-6.833-2.093-10.932-1.16-13.5-.06-3.8 3.116-4.094 8.421-3.92 11.344.076.691.156 1.388.234 2.064v.022c.031.267.063.53.094.789a.648.648 0 0 0 -1.079.369c-.456 1.219 1.206 6.693 1.413 7.031 0 0 .358.562.639.307.785 4.81 2.2 7.77 3.69 9.6-.151 2.7-.633 6.074-.765 6.967-3.489 1.1-20.985 5.756-26.278 9.233a5.026 5.026 0 0 0 -1.465 2.263 41.974 41.974 0 0 0 2.77 3.242c.258.277.525.552.794.823a43.5 43.5 0 0 0 26.784 12.694c1.375.131 2.774.2 4.185.2.48 0 .958-.007 1.432-.025q1.988-.062 3.927-.3a43.4 43.4 0 0 0 19.848-7.683c.61-.436 1.208-.883 1.8-1.349.52-.408 1.032-.83 1.531-1.262a44.052 44.052 0 0 0 4.878-4.944 21.332 21.332 0 0 0 -2.272-4.433z",
    fill: "#ffe5e5",
    transform: "translate(-47.014 84.472)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h51.707v3.068h-51.707z",
    fill: "#e2d2ca",
    transform: "matrix(-1 0 0 -1 663.549 429.874)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m652.089 437.862h4.53v139.593h-4.53z",
    fill: "#706865"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h35.941v4.385h-35.941z",
    fill: "#ccbdb7",
    transform: "matrix(-1 0 0 -1 619.933 430.319)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h13.61v41.337h-13.61z",
    fill: "#4667a8",
    transform: "matrix(-1 0 0 -1 608.767 429.874)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h199.141v7.936h-199.141z",
    fill: "#b59074",
    transform: "matrix(-1 0 0 -1 682.099 437.862)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m521.436 262.834s2.177 30.543-3.791 34.2c-3.739 2.288-18.646 10.012-18.2 11.462s8.417 12.887 8.417 12.887 28.633-18.854 29.556-24.8c.9-5.805-1.408-44.722-5.343-46.515-2.949-1.344-4.5-.234-8.219 2.527-5.218 3.87-2.42 10.239-2.42 10.239z",
    fill: "#323657",
    transform: "translate(198.883 119.053)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m482.217 266.041-2.525-.934s3.148-7.388 4.521-7.209a34.187 34.187 0 0 1 3.557.729z",
    fill: "#ead8cf",
    transform: "translate(185.918 124.567)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "m480.868 267.509c.321-.239 5.363-9.911 5.363-9.911l10.769 1.463-5.82 11.457z",
    fill: "#da9b5b",
    transform: "translate(186.69 124.372)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "m491.449 364.4s.891 6.181 1 7.109 9.9-.547 9.9-.547l.794-7.359s-10.47-.074-11.694.797z",
    fill: "#424773",
    transform: "translate(193.64 193.995)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m498.728 368.066a26.456 26.456 0 0 1 -6.1 5.348c-3 1.624-7.717 2.265-9.492 3.947-1.281 1.211-4.666 6.435 7.8 6.327s18.473.737 19.809-1.264-1.932-14.775-1.932-14.775-2.956 1.061-10.085.417z",
    fill: "#292c47",
    transform: "translate(187.258 196.652)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "m453.578 364.436s.89 6.18 1 7.108 9.9-.547 9.9-.547l.794-7.356s-10.472-.077-11.694.795z",
    fill: "#424773",
    transform: "translate(168.766 194.019)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m463.14 368.1a26.42 26.42 0 0 1 -6.105 5.345c-3 1.625-14.045 2.957-15.819 4.637-1.281 1.213-3.411 6.1 14.126 5.638 12.461-.323 18.473.739 19.81-1.263s-1.934-14.779-1.934-14.779-2.78 1.14-10.078.422z",
    fill: "#292c47",
    transform: "translate(160.102 196.675)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m551.031 299.649s-35.608 6.026-43.648 7.29-51.646 12.111-57.1 15.417c-4.341 2.633 2.276 65.839 3.822 89.954h17.174l1.246-72.337c20.609.517 35.315-4.821 50.324-2.542s27.519 5.519 37.056-7.272c.001 0 .356-27.715-8.874-30.51z",
    fill: "#292c47",
    transform: "translate(165.648 151.991)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "m491.441 409.314 16.737-1.034 1.632-71.362c8.87.222 11.912-.341 19.093-1.211l13.515-31.41c-11.844 2.368-49.789 11.937-54.848 15-4.341 2.639 2.33 65.903 3.871 90.017z",
    fill: "#292c47",
    transform: "translate(190.142 155.044)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "m508.842 219.342s-13.052-3.607-18.031 6.524-2.722 29.342 3.855 31.149 16.038-.273 18.768-6.581 4.909-15.266 4.256-21.068-5.381-8.635-8.848-10.024z",
    fill: "#eea886",
    transform: "translate(191.445 98.836)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m494.416 244.133s.144 7.707-.706 9.349 18.175 1.231 18.175 1.231-3-9.253-1.3-17.138c1.684-7.803-16.169 6.558-16.169 6.558z",
    fill: "#eea886",
    transform: "translate(195.107 109.696)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "m515.434 246.032s-1.016 2.068-5.941 1.733-11.42-6.276-13.509-6.806-2.215-1.72-2.215-1.72l-1.105 1.968-2.142.325s1.455-5.955-1.716-8.052 1.428-18.982 17.484-14.909c0 0 12.255 2.245 12.419 9.089s-.898 14.747-3.275 18.372z",
    fill: "#3a3f47",
    transform: "translate(191.284 98.324)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m493.1 248.145s.053-3.14 1.475-3.44 14.956-2.162 16.7-1.476l.749 4.144s-3.368 2.071-18.924.772z",
    fill: "#e2d2ca",
    transform: "translate(194.721 114.836)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m490.8 231.329c.366-2.571 3.292-5.529 4.965-1.521s-1.13 9.843-3.009 9.53-2.456-4.518-1.956-8.009z",
    fill: "#eea886",
    transform: "translate(193.101 104.83)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "m458.91 268.522a.024.024 0 0 1 .022 0c-.097.04-.112.043-.022 0z",
    fill: "#323657",
    transform: "translate(172.229 131.545)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m502.92 220.2s15.914-.747 2.778 24.095z",
    fill: "#3a3f47",
    transform: "translate(201.174 99.81)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m544.622 380.289-1.185 3.332-50.021-15.5 2.4-6.744z",
    fill: "#918783",
    transform: "translate(194.931 192.534)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h5.686v54.383h-5.686z",
    fill: "#918783",
    transform: "matrix(-1 0 0 -1 692.318 558.282)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h33.532v3.204h-33.532z",
    fill: "#5e5854",
    transform: "matrix(-1 0 0 -1 706.24 504.215)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m463.605 380.457 1.184 3.331 50.021-15.5-2.2-7.168z",
    fill: "#918783",
    transform: "translate(175.353 192.366)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m484.877 383.431v3.869l15.963-19.01-2.2-7.168z",
    fill: "#918783",
    transform: "translate(189.323 192.366)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m460.784 377.441a4.675 4.675 0 1 0 4.674-4.674 4.675 4.675 0 0 0 -4.674 4.674z",
    fill: "#bfb2ac",
    transform: "translate(173.499 200.015)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m484.638 377.441a4.674 4.674 0 1 0 4.674-4.674 4.674 4.674 0 0 0 -4.674 4.674z",
    fill: "#bfb2ac",
    transform: "translate(189.166 200.015)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m521.5 377.441a4.675 4.675 0 1 0 4.675-4.674 4.677 4.677 0 0 0 -4.675 4.674z",
    fill: "#bfb2ac",
    transform: "translate(213.377 200.015)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m3.617 0h72.208a3.617 3.617 0 0 1 3.617 3.617v4.906a3.616 3.616 0 0 1 -3.616 3.616h-72.209a3.617 3.617 0 0 1 -3.617-3.617v-4.905a3.617 3.617 0 0 1 3.617-3.617z",
    fill: "#e2d2ca",
    transform: "matrix(-1 0 0 -1 728.976 501.012)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.532v139.593h-4.532z",
    fill: "#706865",
    transform: "matrix(-1 0 0 -1 512.968 577.455)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m3.607 0h110.311a3.607 3.607 0 0 1 3.607 3.607v75.693a3.607 3.607 0 0 1 -3.607 3.607h-110.31a3.608 3.608 0 0 1 -3.608-3.607v-75.693a3.607 3.607 0 0 1 3.607-3.607z",
    fill: "#5f8be3",
    transform: "matrix(-1 0 0 -1 660.726 408.449)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h108.321v65.434h-108.321z",
    fill: "#f5f7ff",
    transform: "matrix(-1 0 0 -1 656.124 395.457)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h108.321v5.206h-108.321z",
    fill: "#cecfd6",
    transform: "matrix(-1 0 0 -1 656.124 335.229)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#cecfd6",
    height: 52.281,
    rx: 2.233,
    transform: "matrix(-1 0 0 -1 564.867 391.428)",
    width: 13.06
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m1.205 0h21.413a1.205 1.205 0 0 1 1.205 1.205v2.432a1.206 1.206 0 0 1 -1.206 1.206h-21.411a1.206 1.206 0 0 1 -1.206-1.206v-2.432a1.205 1.205 0 0 1 1.205-1.205z",
    fill: "#cecfd6",
    transform: "matrix(-1 0 0 -1 653.06 343.99)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "m2.491 0h18.842a2.49 2.49 0 0 1 2.49 2.49v40.547a2.491 2.491 0 0 1 -2.491 2.491h-18.842a2.49 2.49 0 0 1 -2.49-2.49v-40.547a2.491 2.491 0 0 1 2.491-2.491z",
    fill: "#cecfd6",
    transform: "matrix(-1 0 0 -1 653.06 392.763)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m438.988 271.03a3.791 3.791 0 1 0 3.791-3.792 3.792 3.792 0 0 0 -3.791 3.792z",
    fill: "#fff",
    transform: "translate(159.183 130.703)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m426.592 290.831v-1.476s2.074-9.177 16.745-9.177 14.374 10.653 14.374 10.653z",
    fill: "#314875",
    transform: "translate(151.042 139.202)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m455.924 283.255s-3.186-.247-4.356-.953-8.151-5.4-9.795-4.651-12.562 4.1-12.181 5.7 1.39 1.443 2.16 1.16 8.7-1.948 9.4-1.668c0 0-7.789 2.843-7.82 4.916s1.63 2.58 2.368 3.362 1.627 2.734 3.635 2.881 11.8-3.257 13.818-3.415 5.748.126 6-.2-3.229-7.132-3.229-7.132z",
    fill: "#eea886",
    transform: "translate(153.006 137.489)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m504.814 250.792c10.163-1.786 20.859-4.349 20.859-4.349l18.926-.772s17.372 3.824 24.212 6.914c.648.293.651 15.5 2.432 19.484l-5.671 11.964s-3.277 23.7-3.957 34.244c-.312 4.838.881 46.766.881 46.766s-1.7.84-14.616 2.263-45.191-.515-45.395-2.04 6.249-56.81 6.536-59.671c.439-4.394-1.269-24.7-1.269-24.7-2.434 3.269-8.638 18.031-15.1 25.057-3.806 4.13-22.642 6.664-26.192 6.781-7.729.26-21.827 1.8-22.239 1.045-.33-.451-1.229-12.514-.345-12.809.772-.257 26.954-1.766 33.661-5.323 2.454-1.3 9.79-17.3 9.79-17.3s11.88-25.036 17.487-27.554z",
    fill: "#323657",
    transform: "translate(162.142 116.538)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "m6.945 0h40.895a6.944 6.944 0 0 1 6.944 6.944v61.988a6.944 6.944 0 0 1 -6.944 6.944h-40.896a6.944 6.944 0 0 1 -6.944-6.944v-61.987a6.945 6.945 0 0 1 6.945-6.945z",
    fill: "#e2d2ca",
    transform: "matrix(-1 0 0 -1 747.534 480.371)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m503.142 345.484c8.075 0 14.626-2.714 19.471-8.062 10.953-12.091 8.983-33.346 8.9-34.246a3.048 3.048 0 0 0 -6.066.6c.022.243 1.768 19.509-7.359 29.566-3.69 4.069-8.579 6.047-14.941 6.047a3.048 3.048 0 1 0 0 6.1z",
    fill: "#e2d2ca",
    transform: "translate(199.317 152.504)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m454.357 248.453a15.3 15.3 0 1 1 -15.3-15.3 15.3 15.3 0 0 1 15.3 15.3z",
    fill: "#eef0f7",
    transform: "translate(149.179 108.316)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m446.907 248.894-1.13 4.048a15.211 15.211 0 0 1 -6.957 2.694c-.454.056-.913.093-1.377.106-.167.007-.333.008-.5.008-.5 0-.986-.022-1.468-.07a15.681 15.681 0 0 1 -1.592-.235 15.22 15.22 0 0 1 -6.253-2.856c-.217-1.339-.449-2.818-.653-4.2 1.123-.418 4.7-1.635 6.962-2.4.03-.012.063-.022.093-.031.051-.018.1-.035.147-.05.133-.046.26-.089.384-.129l.351-.121c.462-.154.787-.265.9-.3l.046-.017h.025l3.037.229.51.036.159.012.07.018c.182.046.714.186 1.42.4 1.809.546 4.726 1.593 5.826 2.858z",
    fill: "#d9c7c1",
    transform: "translate(151.294 116.317)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m435.223 237.817s3.642.616 3.024 6.317-3.834 5.2-4.049 5.192-3.234.068-3.391-6.906c-.001.001-.049-5.151 4.416-4.603z",
    fill: "#eea987",
    transform: "translate(153.809 111.354)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m436.332 244.011a13.2 13.2 0 0 0 .095 2.858c.224.51-2.924 2.127-4.879.287a20.156 20.156 0 0 0 .273-3.471c-.121-.906 4.511.326 4.511.326z",
    fill: "#eea987",
    transform: "translate(154.296 115.016)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m435.437 240.714s.4-.421.545.013-.646 2.354-.6 2.442c0 0-.073.167-.169.073a20.656 20.656 0 0 1 .224-2.528z",
    fill: "#eea987",
    transform: "translate(156.694 113.163)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m431.059 240.628s-.386-.441-.547-.012a7.305 7.305 0 0 0 .5 2.464s.124.2.222.109a20.9 20.9 0 0 0 -.175-2.561z",
    fill: "#eea987",
    transform: "translate(153.597 113.095)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m438.655 242.415c-.126.78-.243 1.36-.243 1.36l-.53.693a13.931 13.931 0 0 0 -.05-1.771c-.03-.093-.066-.254-.1-.427-.061-.288-.124-.613-.167-.724a7.8 7.8 0 0 0 -5.84.189s.022.234.022.5c0 .307-.036.648-.176.7-.26.1-.152 1.791-.152 1.791l-.424-.489s-.123-.885-.243-1.9v-.007c-.028-.239-.055-.482-.083-.724a4.77 4.77 0 0 1 1.375-3.98 6.58 6.58 0 0 1 4.733.022 1.632 1.632 0 0 1 .7.186c1.491 1.634 1.178 4.581 1.178 4.581z",
    fill: "#e8734d",
    transform: "translate(153.708 110.977)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m431.862 244.287a2.331 2.331 0 0 0 1.933.779 2.64 2.64 0 0 0 1.937-.736 2.356 2.356 0 0 1 -1.943 1.322 2.382 2.382 0 0 1 -1.927-1.365z",
    fill: "#c78d71",
    transform: "translate(154.503 115.63)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "m431.323 245.952a3.968 3.968 0 0 0 2.828 1.859c1.175.1 2.192-1.388 2.671-2.119a7.116 7.116 0 0 0 -5.499.26z",
    fill: "#eea987",
    transform: "translate(154.149 116.269)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m435.361 245.2a10.106 10.106 0 0 1 -2.331 2.021l.987 1.519 1.683-3z",
    fill: "#eddad3",
    transform: "translate(155.27 116.227)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m431.827 245.334a6.778 6.778 0 0 0 2.382 1.793l-1.082 1.564-1.894-2.739z",
    fill: "#eddad3",
    transform: "translate(154.09 116.317)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m433.374 246.416.847 1.284a1.759 1.759 0 0 1 -1.713-.03z",
    fill: "#5073ab",
    transform: "translate(154.926 117.028)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m443.189 248.531-.025.085c-.093.33-.449 1.6-.915 3.289-.174.151-.355.3-.537.442q-.308.244-.631.472a15.211 15.211 0 0 1 -6.957 2.694c.227-5.3.855-9.992.855-9.992.5.131.968.26 1.412.388a32.472 32.472 0 0 1 6.523 2.462l.013.007c.181.1.262.153.262.153z",
    fill: "#323657",
    transform: "translate(155.989 116.44)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m434.527 255.189a15.219 15.219 0 0 1 -6.253-2.856 15.06 15.06 0 0 1 -1.546-1.359c-.093-.094-.187-.192-.278-.288-.268-1.138-.446-1.88-.457-1.929s1.894-1.244 8.591-3.03c0 .154.003 4.45-.057 9.462z",
    fill: "#323657",
    transform: "translate(150.648 116.574)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "m434.121 247.462c-.061 1.4-.068 4.1-.046 7.189-.167.007-.333.008-.5.008-.5 0-.986-.022-1.468-.07a46.928 46.928 0 0 1 1.017-7.133c.075-.308.119-.462.119-.462l.9.149c-.01.099-.017.205-.022.319z",
    fill: "#5073ab",
    transform: "translate(154.662 117.408)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "m440.952 248.977a15.378 15.378 0 0 1 -1.71 1.735c-.174.151-.355.3-.537.442.007-.018.88-2.565 1.476-3.816.405.27.587 1.188.771 1.639z",
    fill: "#323657",
    transform: "translate(158.997 117.633)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m426.932 249.772c-.093-.094-.187-.192-.278-.288a14.419 14.419 0 0 1 -.969-1.138 1.747 1.747 0 0 1 .512-.792z",
    fill: "#323657",
    transform: "translate(150.445 117.775)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "m372.338 361.647a13.353 13.353 0 0 0 -4.729-4.531c-2.732-1.271-8.335 3.166-8.827 5.633l-6.495 9.475 1.229.845 3.468-5.058c-2.361 5.68-5.734 12.481-3.363 15.9 3.179 4.589 10.391 9.228 12.3 8.425s1.524-14.146 1.524-14.146c-2.061-11.78 4.893-16.543 4.893-16.543z",
    fill: "#1d3b54",
    transform: "translate(102.239 189.587)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m369.767 361.558a73.367 73.367 0 0 0 -3.584 8.085c-1.216 3.532-1.445 13.317-2.21 14s-6.809-2.371-7.616-6.029 1.643-10.974 3.976-14.814a23.907 23.907 0 0 1 4.705-5.769s4.12.798 4.729 4.527z",
    fill: "#de9673",
    transform: "translate(104.809 189.676)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m391.9 308.009s-3.7 19.643-3.7 24.34a43.2 43.2 0 0 1 -4.27 18.077c-2.987 5.7-16.1 44.593-17.244 49.126s-2.114 8.808-2.114 8.808-6.548-2.989-6.548-7.26 5.694-39.569 6.69-46.544 9.253-42.7 9.253-42.7z",
    fill: "#de9673",
    transform: "translate(106.003 157.481)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m375.21 307.55s1.281 16.369 1.138 20.639-2.136 13.95-2.136 16.513 0 55.648 2.124 62.054-5.966 2-5.966 2-14.091-34.917-14.091-49.485 1.707-21.827.711-31.08-5.426-21.431-5.426-21.431z",
    fill: "#eea886",
    transform: "translate(101.764 156.659)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m356.968 259.681a50.9 50.9 0 0 0 -9.57 21.664c-1.991 12.385 2.359 35.736 3.908 42.492 1.357 5.93 3.953 24.905 4.1 26.9 0 0 25.47 2.884 44.828-3.236 0 0 1.771-26.5 2.911-37.748s-4.419-49.217-4.419-49.217z",
    fill: "#3876c8",
    transform: "translate(98.691 125.739)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "m377.308 383.574c-9.124-7.968-6.682-16.149-6.682-16.149s-3.648-1.3-6.609-.557-4.55 7.8-3.365 10.06l.923 11.6 1.5-.123-.492-6.191c1.76 5.978 3.433 13.483 7.479 14.666 5.428 1.589 14.063.648 15.054-1.2s-7.808-12.106-7.808-12.106z",
    fill: "#1d3b54",
    transform: "translate(107.474 195.99)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "m378.008 207.413s-2.257 13.437-.306 17.948-10.36-5.275-10.36-5.275 5.108-14.804 10.666-12.673z",
    fill: "#754836",
    transform: "translate(112.127 91.272)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m380.113 184.961s-19.759-4.523-22.219 16.59 6.428 23.763.411 38.072 14.695-4.661 14.695-4.661z",
    fill: "#754836",
    transform: "translate(105.471 76.396)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m376.827 184.615c5.071-.1 16.235 2.764 17.589 16.237a41.979 41.979 0 0 1 -1.466 6.427c-.958 2.818 1.354 11.273.676 11.669a18.556 18.556 0 0 1 -3.438.845s-3.213 9.076-6.427 8.907-15.314-3.025-20.725-14.583-6.69-29.088 13.791-29.502z",
    fill: "#eea886",
    transform: "translate(107.054 76.435)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m336.648 289.37s.474-8.125 2.624-9.386.908 1.253.908 1.253-1.208 5.895-1.474 8.284a12.183 12.183 0 0 1 -2.058-.151z",
    fill: "#1d3b54",
    transform: "translate(91.967 138.842)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m346.482 276.647a59.676 59.676 0 0 0 1.7 7.154c1.1 3.511 2.121 4.631 1.678 6.642-.335 1.519-2.053 2.659-2.487 2.174s-.643-6.394-3.09-6.365.731 7.313-.726 6.778-7.061-3.607-6.708-6.582 2.594-5.128 2.45-9.573c-.131-4.034 1.125-5.721 1.125-5.721z",
    fill: "#eea886",
    transform: "translate(92.091 133.274)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m342.135 280.13s3.259.833 3.065 11.854l-3.69-.616s.07-6.09-1.034-9.411c.001 0 .19-2.157 1.659-1.827z",
    fill: "#1d3b54",
    transform: "translate(94.482 139.148)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "m361.033 292-28.73-8.15.084 35.383 28.593 17.138z",
    fill: "#eddad3",
    transform: "translate(89.113 141.615)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m362.063 336.373-3.6.663-27.81-17.294.347-35.728 2.388-.162z",
    fill: "#eddad3",
    transform: "translate(88.03 141.615)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m387.194 215.712s7.659 3.145 9.026 4.1 4.1 12.035 4.787 12.993 7.292 9.17 6.377 15.829c-.717 5.232-3.675 8-5.59 10.052s-3.688 13.1-4.288 14.736 1.309 23.184 1.309 23.184-22.473 8.746-42.575-6.16c0 0 4.013-14.424 4.013-17.024s-2.6-20.924-9.573-31.728 1.231-22.292 6.564-23.657 15.59-5.2 15.59-5.2z",
    fill: "#3876c8",
    transform: "translate(99.419 94.974)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m369.69 215s-11.246-.693-16.888 5.872-5.333 14.359-6.77 17.744-4.719 17.948-5.436 20.309-1.418 15.619-2.444 26.285-.818 30.586-.818 30.586l10.761-1.952s.434-18.987.707-30 9.23-30.462 12.615-38.976 16.862-24.527 8.273-29.868z",
    fill: "#3876c8",
    transform: "translate(92.407 96.379)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m378.29 216.674a9.283 9.283 0 0 1 7.3 5.237c2.359 4.924 3.262 9.018 3.877 10.249s9.149 17.444 9.662 21.035-.308 10.154-4.821 11.9-20.718 1.947-20.718 1.947 4.1-8.335.306-12.645c0 0 11.762-2.124 14.545-2.406 2.941-.291-13.877-31.626-10.151-35.317z",
    fill: "#3876c8",
    transform: "translate(116.234 97.492)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m360.168 229.372 21.914 51.18 27.318-12.87-20.2-49.149z",
    fill: "#1d3b54",
    transform: "translate(107.415 98.714)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m369.44 240.252s-2.966.789-3.907.926.222 1.875 1.375 1.929 2.532-2.855 2.532-2.855z",
    fill: "#eea886",
    transform: "translate(110.713 112.978)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m371.431 255.347a6.284 6.284 0 0 0 1.965-.391s1.024-.673 1.779-1.1a5.953 5.953 0 0 1 .6-.31 11.485 11.485 0 0 0 3.3-1.607c1.287-1 5.477-4.994 5.477-4.994l-2.77-4.177-2.141-3.324s-9 .247-10.314 1.04a3.7 3.7 0 0 0 -.36.247 14.662 14.662 0 0 0 -1.99 2.266c-.184.174-1.882 2.03-1.781 2.773a2.46 2.46 0 0 0 1.3 2 5.887 5.887 0 0 0 1.417 2.9 3.647 3.647 0 0 0 1.9 2.6s.496 1.865 1.618 2.077z",
    fill: "#eea886",
    transform: "translate(110.714 112.446)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m373.78 247.653s13.342-2.384 17.027-2.773a46.029 46.029 0 0 0 -.421-8.649c-.674-3.968-3.932-9.29-3.932-9.29l6.823 6.248s5.61 10.748 5.736 13.263.79 6.392-2.528 10.325-18.989 2.132-18.989 2.132 1.309-4.825-3.716-11.256z",
    fill: "#3876c8",
    transform: "translate(116.355 104.236)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m377.3 214.165s-.432 1.272-.934 3.165c-.257.968-.533 2.1-.78 3.3-.678 3.327-1.128 7.222-.336 9.848 0 0-7.179 2.262-12.51-7.943 0 0 2.715-10.758-.234-17.41s14.794 9.04 14.794 9.04z",
    fill: "#eea886",
    transform: "translate(108.732 88.827)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m394.841 201.728s-8.381 5.372-16.574 6.272-12.749 13.3-12.749 13.3-12.882-20.057-2.508-32.384 34.048-2.785 31.831 12.812z",
    fill: "#754836",
    transform: "translate(106.628 75.558)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m370.689 199c0-1.582-1.69-4-4.341-1.917s.62 9.7 2.762 9.02 1.579-5.471 1.579-7.103z",
    fill: "#eea886",
    transform: "translate(110.824 84.093)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m379.108 216.229s3.376 9.967-4.521 9.914-11.336-6.261-13.591-11.77a28.678 28.678 0 0 1 5.333-2.025c1.692-.256 12.779 3.881 12.779 3.881z",
    fill: "#eea886",
    transform: "translate(107.959 94.644)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m344.8 287.477-3.7.479v-1.728z",
    fill: "#1d3b54",
    transform: "translate(94.889 143.175)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "m338.72 285.688-2.046.243s-.007-.616.012-.82 1.962.447 2.034.577z",
    fill: "#1d3b54",
    transform: "translate(91.983 142.415)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m369.3 367.614a74.748 74.748 0 0 0 2.329 8.652c1.292 3.557 7.345 11.407 7.174 12.431s-6.874 2.472-9.838.1-5.694-9.689-6.306-14.2a33.538 33.538 0 0 1 -.288-7.427s4.071-2.107 6.929.444z",
    fill: "#eea886",
    transform: "translate(108.803 195.801)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m375.3 213.047c-.257.968-.638 2.132-.934 3.285a34.225 34.225 0 0 1 -9.59-9.578c3.674 3.519 10.524 6.293 10.524 6.293z",
    fill: "#a77860",
    transform: "translate(110.439 90.977)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#dfe1e8",
    height: 53.436,
    rx: 6.805,
    width: 98.96,
    x: 174.001,
    y: 112.227
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m152.246 256.738a.053.053 0 0 0 -.023 0c.099.043.114.048.023 0z",
    fill: "#323657",
    transform: "translate(-29.163 123.805)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffe5e5",
    height: 9.617,
    rx: 2.225,
    transform: "matrix(-1 0 0 -1 152.798 372.02)",
    width: 80.473
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffe5e5",
    height: 9.616,
    rx: 2.225,
    transform: "matrix(-1 0 0 -1 152.798 389.365)",
    width: 80.473
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "m2.225 0h76.023a2.225 2.225 0 0 1 2.225 2.225v5.169a2.224 2.224 0 0 1 -2.224 2.224h-76.024a2.225 2.225 0 0 1 -2.225-2.225v-5.168a2.225 2.225 0 0 1 2.225-2.225z",
    fill: "#ffe5e5",
    transform: "matrix(-1 0 0 -1 152.798 406.711)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "m4.145 0h22.9a4.144 4.144 0 0 1 4.144 4.144v59.418a4.144 4.144 0 0 1 -4.144 4.144h-22.901a4.144 4.144 0 0 1 -4.144-4.144v-59.417a4.145 4.145 0 0 1 4.145-4.145z",
    fill: "#ffe5e5",
    transform: "translate(174.637 257.615)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m89.145 297.115a10.359 10.359 0 0 1 1.349 3.565 17.106 17.106 0 0 0 1.649 4.212 40.336 40.336 0 0 1 2 7.02c.022.5-1.1 3.683-.944 4.7s.741 3.03-.172 3.164-1.948-1.516-1.948-1.516a1.34 1.34 0 0 1 -.686 1.292 2.258 2.258 0 0 1 -2.3.083s-.555 1.031-1.249 1.17a2.829 2.829 0 0 1 -2.285-.31 2.773 2.773 0 0 1 -1.736.557 2.277 2.277 0 0 1 -1.925-1.2s-1.716.348-2.213-.452a7.7 7.7 0 0 1 -.618-2.381 27.73 27.73 0 0 1 2.175-12c2.227-4.717-.565-9.321-.565-9.321z",
    fill: "#eea886",
    transform: "translate(-77.911 149.397)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m91.357 312.38s.152-5.88-1.4-7.131-1.723.87-1.723.87.21-2.1-1.481-2.381-1.763 2.209-1.763 2.209a1.635 1.635 0 0 0 -2.053-1.286c-1.776.331-1.354 2.4-1.354 2.4s-1.7-2.025-2.8-.081c-1.857 3.282-.066 7.159-.066 7.159s.524.888 2.213.452c0 0 1.132 2.278 3.662.641 0 0 2.59 1.425 3.534-.86.007-.002 2.862 1.355 3.231-1.992z",
    fill: "#db9c7c",
    transform: "translate(-77.947 154.662)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m108.976 250.877s-10.067 33.548-13.468 45.923c-1.065 3.88-3.648 40.943-4.1 42.436s-13.225 3.537-13.225 3.537 1.547-46.367 1.692-48.9 14.088-54.308 18.142-56.156c3.039-1.383 4.642-.239 8.471 2.6 5.369 3.999 2.488 10.56 2.488 10.56z",
    fill: "#323657",
    transform: "translate(-77.794 110.933)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h27.537v2.045h-27.537z",
    fill: "#4da8f2",
    transform: "matrix(.83687898 -.54738796 .54738796 .83687898 129.343 314.811)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m178.8 215.983a6.023 6.023 0 0 1 -.595 1.827s-.754.9-1.251 1.569a5.762 5.762 0 0 0 -.361.535 11.056 11.056 0 0 1 -1.9 2.959c-1.1 1.112-5.371 4.652-5.371 4.652l-3.661-3.108-3.8-1.7s2.131-9.253 3.032-10.408a3.431 3.431 0 0 1 .275-.315 13.866 13.866 0 0 1 2.382-1.639c.186-.154 2.142-1.564 2.84-1.382a2.351 2.351 0 0 1 1.756 1.466 5.63 5.63 0 0 1 2.6 1.675 3.5 3.5 0 0 1 2.263 2.1s1.713.678 1.791 1.769z",
    fill: "#efaa88",
    transform: "translate(-22.837 92.422)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m96.618 384.013s-.918 6.367-1.032 7.326-10.208-.565-10.208-.565l-.817-7.583s10.794-.076 12.057.822z",
    fill: "#424773",
    transform: "translate(-73.603 206.859)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "m96.319 387.789a27.192 27.192 0 0 0 6.289 5.511c3.093 1.672 7.953 2.334 9.782 4.066 1.32 1.251 4.808 6.63-8.037 6.523s-19.037.761-20.413-1.3 1.991-15.228 1.991-15.228 3.041 1.092 10.388.428z",
    fill: "#292c47",
    transform: "translate(-74.228 209.598)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "m140.263 384.013s-.918 6.367-1.032 7.326-10.208-.565-10.208-.565l-.817-7.583s10.794-.076 12.057.822z",
    fill: "#424773",
    transform: "translate(-44.937 206.859)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m139.964 387.789a27.217 27.217 0 0 0 6.291 5.511c3.092 1.672 14.472 3.047 16.3 4.778 1.32 1.251 3.517 6.281-14.557 5.81-12.84-.335-19.038.761-20.413-1.3s1.99-15.228 1.99-15.228 2.867 1.168 10.389.429z",
    fill: "#292c47",
    transform: "translate(-45.561 209.598)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m105.6 284.911s-9.484 15.067-8.776 28.686-3.438 28.489-4.863 42.715c-1.587 15.861-8.087 53.409-8.324 61.893s1.009 35.576 1.009 35.576l13.011.3s10.927-65.642 13.756-72.341 16.863-54.451 17.335-59.809-23.148-37.02-23.148-37.02z",
    fill: "#292c47",
    transform: "translate(-74.229 142.311)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m148.7 287.983s7.146 37.328 8.089 45.661 1.572 40.34 2.044 45.549 4.405 68.018 5.66 75.914h-16.638s-12.767-45.771-12.767-67.43-9.863-47.081-16.23-61.371-20.942-14.626-24.858-41.138c0 0 49.4-5.595 54.7 2.815z",
    fill: "#292c47",
    transform: "translate(-67.403 141.282)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m109.591 208.918s12.729-4.753 18.6 4.936 5.3 29.085-1.112 31.471-16.054 1.137-19.34-4.924-6.249-14.828-6.107-20.685 4.617-9.106 7.959-10.798z",
    fill: "#eea886",
    transform: "translate(-62.396 91.633)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "m124.258 235.488s-.53 3.436.345 5.129-16.49 1.736-16.49 1.736a114.493 114.493 0 0 0 -4.082-16.989c-2.673-7.778 20.227 10.124 20.227 10.124z",
    fill: "#eea886",
    transform: "translate(-60.959 101.914)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m105.887 236.227s1.2 1.978 6.092 1.211 10.86-7.275 12.9-7.992 2.063-1.914 2.063-1.914l1.279 1.869 2.169.137s-1.978-5.824 1.007-8.2-3.1-18.848-18.79-13.364c0 0-12.052 3.322-11.612 10.174s2.195 14.666 4.892 18.079z",
    fill: "#d88a51",
    transform: "translate(-62.815 91.052)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m124.714 235.557s-.053-3.234-1.521-3.546-16.182-1.725-17.981-1.017v3.768s3.468 2.138 19.502.795z",
    fill: "#e2d2ca",
    transform: "translate(-60.04 106.77)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m118.271 218.827c-.275-1.15-3.2-4.435-4.318-.918s1.692 8.249 3.259 7.843 1.755-4.011 1.059-6.925z",
    fill: "#eea886",
    transform: "translate(-54.466 97.265)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m159.943 249.961c-10.092-1.33-24.343-4.9-24.343-4.9l-19.5-.794s-17.9 3.94-24.95 7.124c-.669.3-.671 15.97-2.507 20.077l5.841 12.332s3.377 24.426 4.077 35.29c.321 4.985-6.964 46.76-6.964 46.76a134.667 134.667 0 0 0 21.118 3.766c13.311 1.466 46.569-.53 46.78-2.1s-6.442-58.543-6.735-61.494c-.452-4.528 1.561-28.59 1.561-28.59 3.073-2.384 30.058-14.91 37.419-21.437 1.972-1.748 10.285-9.845 12.651-12.64 8.37-9.9 15.231-18.389 16.066-20.218.948-1.042-9.094-6.5-10.005-6.806-.8-.267-12.113 14.394-16.467 19.111-1.942 2.1-10.015 7.977-10.015 7.977s-17.715 6.905-24.027 6.542z",
    fill: "#323657",
    transform: "translate(-70.925 97.264)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m107.164 209.146s-16.23 1.271-.5 25.584z",
    fill: "#d88a51",
    transform: "translate(-63.594 92.548)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m171.042 209.8 1.332-2.031-2.451.32z",
    fill: "#dfe1e8",
    transform: "translate(-17.538 91.644)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImage);
export default __webpack_public_path__ + "static/media/header-image.14fee79e602d1d261f7a832bf4d1c8da.svg";
export { ForwardRef as ReactComponent };